import * as React from 'react';
import { StatsRow } from './StatsRow';

interface LocationStatsRowProps {
  venueId: string;
  fulfillmentCenterId: string;

  id: string;
  name: string;
  stats: {
    orders: number;
    sales: number;
    tips: number;
    averageTipPercentage: number;
  };
}

export const LocationStatsRow = (props: LocationStatsRowProps) => {
  const { venueId, fulfillmentCenterId, id } = props;

  return (
    <div>
      <div className='delivery-location-live-stats-location-row'>
        <h3 className='text-center mt-5'>{props.name}</h3>
        <div className='text-right mb-3'>
          <a
            className='font-weight-bold'
            href={`/venue/${venueId}/fulfillment-centers/${fulfillmentCenterId}/live-stats/${id}`}
          >
            View more
          </a>
        </div>
      </div>
      <StatsRow {...props.stats} />
    </div>
  );
};
